import MultiDimmingIndicator from './component'

export default MultiDimmingIndicator
